module.exports = __webpack_public_path__ + "static/Lamentum5-47187a2f4cd4bef97a83a758995b3737.png";